import { Pipe, PipeTransform } from '@angular/core';
import { isAfter, isValid } from 'date-fns';

@Pipe({
  name: 'dateIsAfter',
  standalone: true,
})
export class DateIsAfterPipe implements PipeTransform {
  transform(
    date: Date | null | undefined,
    dateToCompare: Date | null | undefined,
  ): boolean {
    return (
      !!date &&
      !!dateToCompare &&
      isValid(date) &&
      isValid(dateToCompare) &&
      isAfter(date, dateToCompare)
    );
  }
}
